<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">

    <div class="animated fadeIn">

                <div class="row">
                    <div class="col-md-12">
                        <h4>Buscador de Permisos Acciones Impresos I y III</h4>

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                               aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-filter"></i> Filtros
                                    <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body">
                                
                                <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpAccion">Acción</label>

                                            <ng-select [items]="listAcciones"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdAccion"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listAcciones || listAcciones.length === 0"
                                                       notFoundText="Acción no encontrada"
                                                       placeholder="-- Seleccione una Acción --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdAccion')"
                                                       appendTo="body">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="intAccionDescripcion">Descripción de la Acción</label>
                                            <input formControlName="IdAccionDescripcion" name="IdAccionDescripcion" class="form-control" inputStyleClass="form-control" type="text" value="" maxlength="50">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpPerfil">Perfil</label>

                                            <ng-select [items]="listPerfiles"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPerfil"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPerfiles || listPerfiles.length === 0"
                                                       notFoundText="Perfil no encontrado"
                                                       placeholder="-- Seleccione un Perfil --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPerfil')"
                                                       appendTo="body">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="EstadoImpresoIyIII">Estado</label>

                                            <ng-select [items]="listEstadosImpresosIyIII"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdEstadoImpresoIyIII"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listEstadosImpresosIyIII || listEstadosImpresosIyIII.length === 0"
                                                       notFoundText="Estado de Impresos I y III no encontrado"
                                                       placeholder="-- Seleccione un Estado para los Impresos I y III --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdEstadoImpresoIyIII')"
                                                       appendTo="body">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <div>
                                                <label class="col-form-label" for="Edicion">Edición</label>
                                                <p-selectButton class="selectButtonCust"
                                                                [options]="listSiNoTodos"
                                                                formControlName="Edicion"
                                                                unselectable="true">
                                                </p-selectButton>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group-0 float-right">

                                            <div class="btn-group">
                                                <button [disabled]="disableSearchBtn" name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                        title="Realiza una búsqueda" (click)="onSearch($event)">
                                                    <i class="fa fa-search"></i> Buscar
                                                </button>
                                            </div>

                                            <div class="btn-group">
                                                <button class="btn btn-secondary btn-sm" type="button"
                                                        title="Limpia los filtros" (click)="resetForm($event)">
                                                    <i class="fa fa-eraser"></i> Limpiar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
    </div>

</form>
